import baseConfigs from './base';

const configs = {
    ...baseConfigs,
    API_BUS_MANAGEMENT: 'https://api-dev.futabus.vn',
    // API_BUS_MANAGEMENT: 'http://10.60.10.91:9009',
    API_V1: 'https://api-dev.vato.vn',
    API_V2: 'https://apiv2-dev.vato.vn',
    API_STORAGE: 'https://api-dev.futabus.vn/storage',
    API_OFFICE: 'https://api-office-dev.vato.vn',
    API_ADMIN: 'https://api-admin-dev.vato.vn',
    API_TRACKING: 'https://api-dev.vato.vn/tracking',
    API_FUTA_USER: 'https://api-dev.futabus.vn',
    WEB_ADMIN_HOST: 'https://admin-dev.vato.vn',
    FIREBASE_API_KEY: 'AIzaSyBSmhKEl_YZy-TT0exuvtSCg8AgvFccqMI',
    FIREBASE_AUTH_DOMAIN: 'vato-2019-dev.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://vato-2019-dev.firebaseio.com',
    FIREBASE_PROJECT_ID: 'vato-2019-dev',
    FIREBASE_STORAGE_BUCKET: 'vato-2019-dev.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '317038682796',
    FIREBASE_APP_ID: '1:317038682796:web:8a09d1a366a4d562b9f509',
    FIREBASE_MEASUREMENT_ID: 'G-10GMGFYMFC',
    FIREBASE_VAPID: 'BEfW7ioBwwARElIko8M064EFtFt7hNNFOk6yqqGVxywH3H18rPjfUDdaTWUIBp-2CiFlA3umyCrXUmqfj4IiY9U',
    gaTrackerId: 'G-FCVQFQ5D98',
    GOOGLE_MAP_KEY: 'AIzaSyBvJoggZQ6BKUruD9EAk-1w7KohjSNP6Gk',
    CRM_WEB: 'https://crm-dev.futabus.vn/',
    X_APP_ID: 'vn.futa.admin.city.bus',
};

export default Object.freeze(configs);
